import { render, staticRenderFns } from "./RequestPageViewerPage.vue?vue&type=template&id=6835a12c"
import script from "./RequestPageViewerPage.vue?vue&type=script&lang=ts"
export * from "./RequestPageViewerPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports